module.exports = __webpack_public_path__ + "img/143.4c4c304d.jpg";